// import React, { useEffect, useState } from "react";
// import axios from 'axios';
// import "./WebinarFormPopup.css";
// import qrCodeImage from "../Assets/Payment-Qr.png";
// import Terms from '../components/Terms';
// import { motion } from "framer-motion";
// import { v4 as uuidv4 } from 'uuid';
// import { useParams } from "react-router-dom";


// export default function WebinarForm() {
 
//   const initialFormData = {
//     firstName: "",
//     lastName: "",
//     profession: "",
//     course: "",
//     phone: "",
//     email: "",
//     batch: "",
//     message: "",
//     paymentScreenshot: null,
//     termsAccepted: false,
//   };

//   const [formData, setFormData] = useState(initialFormData);
//   const [errors, setErrors] = useState({});
//   const [showQRCode, setShowQRCode] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [callbackPhone, setCallbackPhone] = useState("");
//   const [callbackLoading, setCallbackLoading] = useState(false);
//   const [callbackError, setCallbackError] = useState("");

//   const courses = [
//     { name: "Basic", amount: 2400 },
//     { name: "Intermediate", amount: 6000 },
//     { name: "Advanced", amount: 7800 },
//     { name: "TOEFL", amount: 12300 },
//     { name: "IELTS", amount: 12300 },
//   ];

//   const batches = [
//     "1st Sept 2025 – Morning 7am batch (45 minutes)",
//     "1st Sept 2025 – Evening 7pm batch (45 minutes)",
//     "5th Sept 2025 – Morning 6am batch (45 minutes)",
//     "5th Sept 2025 – Evening 8pm batch (45 minutes)",
//   ];

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleReset = () => {
//     setFormData(initialFormData);
//     setErrors({});
//   };

//   const validate = () => {
//     const newErrors = {};
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[0-9]{10}$/; // exactly 10 digits

//     if (!formData.profession.trim()) newErrors.profession = "Profession is required";
//     if (!formData.course) newErrors.course = "Please select a course";
//     if (!formData.batch) newErrors.batch = "Please select a batch";

//     // Phone validation (required)
//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone number is required";
//     } else if (!phoneRegex.test(formData.phone)) {
//       newErrors.phone = "Enter a valid 10-digit phone number";
//     }

//     // Email validation (optional, but must be valid if present)
//     if (formData.email.trim() && !emailRegex.test(formData.email)) {
//       newErrors.email = "Enter a valid email address";
//     }

//     if (!formData.termsAccepted) newErrors.termsAccepted = "You must accept the terms";

//     return newErrors;
//   };

//   const validatePhone = (number) => {
//     // Accepts 10 digits, optional +91 or 0 at start
//     const regex = /^(\+91|0)?[6-9]\d{9}$/;
//     return regex.test(number);
//   };

//   const handleCallbackSubmit = async (e) => {
//     e.preventDefault();

//     if (!validatePhone(callbackPhone)) {
//       setCallbackError("Please enter a valid 10-digit mobile number");
//       return;
//     }

//     setCallbackError("");
//     setCallbackLoading(true);

//     try {
//       const res = await fetch("https://newzealacademy.com/send-callback.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ phone: callbackPhone }),
//       });

//       const data = await res.json();
//       alert(data.message);
//       setCallbackPhone("");
//     } catch (error) {
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setCallbackLoading(false);
//     }
//   };
//   const getToken = () => {
//     const requestHeaders = {
//       "Content-Type": "application/x-www-form-urlencoded"
//     };

//     const requestBodyJson = {
//       "client_version": 1,
//       "grant_type": "client_credentials",
//       "client_id": "SU2510071940251246168190",
//       "client_secret": "a7d45536-e8fd-42db-88e5-13d3d127d3e9"
//     };

//     const requestBody = new URLSearchParams(requestBodyJson).toString();

//     const options = {
//       method: 'POST',
//       url: 'https://api-preprod.phonepe.com/apis/pg-sandbox/v1/oauth/token',
//       headers: requestHeaders,
//       data: requestBody
//     };

//     axios.request(options)
//       .then(function (response) {
//         return response.data;
//       })
//       .catch(function (error) {
//         return error;
//       });
//   }
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const newErrors = validate();
//   //   if (Object.keys(newErrors).length) {
//   //     setErrors(newErrors);
//   //     return;
//   //   }


//   //   setCallbackLoading(true);

//   //   try {
//   //     const response = await fetch("https://newzealacademy.com/RegisterWebinar.php", {
//   //       method: "POST",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify(formData),
//   //     });

//   //     const result = await response.json();

//   //     if (result.status === "success") {
//   //       // setSubmitted(true);
//   //       alert("Thank you for enrolling to the Webinar! Please mark the calendar for the webinar.");
//   //       handleReset();
//   //     } else {
//   //       alert("Failed to send email. Please try again.");
//   //       console.error(result.message);
//   //     }
//   //   } catch (error) {
//   //     console.error(error);
//   //     alert("Something went wrong. Please try again.");
//   //   }

//   //   setLoading(false);
//   //   setSubmitting(true);
//   //   try {
//   //     const requestHeaders = {
//   //       "Content-Type": "application/x-www-form-urlencoded"
//   //     };

//   //     const requestBodyJson = {
//   //       "client_version": 1,
//   //       "grant_type": "client_credentials",
//   //       "client_id": "SU2510071940251246168190",
//   //       "client_secret": "a7d45536-e8fd-42db-88e5-13d3d127d3e9"
//   //     };;

//   //     const requestBody = new URLSearchParams(requestBodyJson).toString();

//   //     const options = {
//   //       method: 'POST',
//   //       url: 'https://api.phonepe.com/apis/identity-manager/v1/oauth/token',
//   //       headers: requestHeaders,
//   //       data: requestBody
//   //     };

//   //     axios.request(options)
//   //       .then(function (response) {
//   //         if (response.data.access_token) {
//   //           const requestHeadersPayment = {
//   //             "Content-Type": "application/json",
//   //             "Authorization": `O-Bearer ${response.data.access_token}`
//   //           };
//   //           const xc = "Tr-" + uuidv4().toString(36).slice(-6)
//   //           const requestBodyPayment = {
//   //             "amount": 100,
//   //             "expireAfter": parseInt(selectedCourse.amount),
//   //             "metaInfo": {
//   //               "udf1": "additional-information-1",
//   //               "udf2": "additional-information-2",
//   //               "udf3": "additional-information-3",
//   //               "udf4": "additional-information-4",
//   //               "udf5": "additional-information-5"
//   //             },
//   //             "paymentFlow": {
//   //               "type": "PG_CHECKOUT",
//   //               "message": "Payment message used for collect requests",
//   //               "merchantUrls": {
//   //                 "redirectUrl": `https://newzealacademy.com/enroll-for-course?id=${xc}`
//   //               }
//   //             },
//   //             "merchantOrderId": xc
//   //           };

//   //           const optionsPayment = {
//   //             method: 'POST',
//   //             url: 'https://api.phonepe.com/apis/pg/checkout/v2/pay',
//   //             headers: requestHeadersPayment,
//   //             data: requestBodyPayment
//   //           };

//   //           axios.request(optionsPayment)
//   //             .then(function (responsePayment) {
//   //               console.log(responsePayment.data);
//   //               window.location.href = responsePayment.data.redirectUrl;
//   //             })
//   //             .catch(function (error) {
//   //               console.error(error);
//   //             });
//   //         }
//   //       })
//   //       .catch(function (error) {
//   //         console.error(error);
//   //       });

//   //   } catch (error) {
//   //     alert("An error occurred while sending the form. Please try again later.");
//   //   } finally {
//   //     setSubmitting(false);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validate();

//     if (Object.keys(validationErrors).length > 0) {
//       focusFirstError(validationErrors);
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch("https://newzealacademy.com/RegisterWebinar.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (result.status === "success") {
//         setSubmitted(true);
//         alert("Thank you for enrolling to the Webinar! Please mark the calendar for the webinar.");
//         handleReset();
//       } else {
//         alert("Failed to send email. Please try again.");
//         console.error(result.message);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong. Please try again.");
//     }

//     setLoading(false);
//   };
//   const selectedCourse = courses.find((c) => c.name === formData.course);

//   return (
//     <div className="webinar-container">
//       <h2 style={{ textAlign: "center" }}>Enroll to Our Course</h2>
//       {/* <p style={{ textAlign: "center" }}>✨ Kickstart your journey with our Beginner's and Intermediate Courses starting on 24th September — 
//         with batches at 7 AM, 11:30 AM, and 8 PM. 🚀</p> */}

//       <form onSubmit={handleSubmit} className="webinar-form">
//         <input type="text" name="firstName" placeholder="First Name*" value={formData.firstName} onChange={handleChange} required />
//         <input type="text" name="lastName" placeholder="Last Name*" value={formData.lastName} onChange={handleChange} required />

//         <div>
//           <input type="text" name="profession" placeholder="Profession*" value={formData.profession} onChange={handleChange} required />
//           {errors.profession && <p className="error">{errors.profession}</p>}
//         </div>

//         <div>
//           <select name="course" value={formData.course} onChange={handleChange} required>
//             <option value="">Select Course*</option>
//             {courses.map((c) => (
//               <option key={c.name} value={c.name}>{c.name}</option>
//             ))}
//           </select>
//           {selectedCourse && <p className="course-amount">Fees: ₹{selectedCourse.amount}</p>}
//           {errors.course && <p className="error">{errors.course}</p>}
//         </div>

//         <div>
//           <select
//             name="batch"
//             value={formData.batch}
//             onChange={handleChange}
//             required
//             disabled={!formData.course}
//           >
//             <option value="">
//               {formData.course ? "Select Batch*" : "Select a Course First"}
//             </option>
//             {formData.course &&
//               batches.map((b, index) => (
//                 <option key={index} value={b}>
//                   {b}
//                 </option>
//               ))}
//           </select>
//           {errors.batch && <p className="error">{errors.batch}</p>}
//         </div>

//         <div>
//           <input type="tel" name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} required />
//           {errors.phone && <p className="error">{errors.phone}</p>}
//         </div>

//         <div>
//           <input type="email" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} required />
//           {errors.email && <p className="error">{errors.email}</p>}
//         </div>

//         <textarea name="message" placeholder="Any message" value={formData.message} onChange={handleChange} />

//         <div className="terms-container">
//           <input
//             type="checkbox"
//             name="termsAccepted"
//             checked={formData.termsAccepted}
//             onChange={handleChange}
//           />
//           <label>
//             I agree to the{" "}
//             <span className="terms-link" onClick={() => setShowModal(true)}>
//               Terms & Conditions
//             </span>
//           </label>
//           {errors.termsAccepted && <p className="error">{errors.termsAccepted}</p>}
//         </div>

//         <div className="btn-group">
//           <button type="button" className="submit-btn" onClick={handleReset}>Reset</button>
//           <button type="submit" className="submit-btn" disabled={!formData.termsAccepted || submitting}>
//             {submitting ? "Submitting..." : "Submit"}
//           </button>
//         </div>
//       </form>

//       {/* Moved callback form outside the main form */}
//       <motion.form
//         onSubmit={handleCallbackSubmit}
//         initial={{ y: 30, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
//         className="callback-form"
//       >
//         <input
//           type="tel"
//           placeholder="Enter your phone number"
//           value={callbackPhone}
//           onChange={(e) => setCallbackPhone(e.target.value)}
//           required
//           className="callback-input"
//         />
//         <button
//           type="submit"
//           className="callback-button"
//           disabled={callbackLoading}
//         >
//           {callbackLoading ? "Submitting..." : "Request a Call Back"}
//         </button>

//         {callbackError && <p className="error-text">{callbackError}</p>}
//       </motion.form>

//       {showQRCode && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <button className="close-btn" onClick={() => setShowQRCode(false)}>X</button>
//             <h3>Scan to Complete Payment</h3>
//             <img src={qrCodeImage} alt="QR Code" className="qr-code" />
//           </div>
//         </div>
//       )}

//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <button className="close-btn" onClick={() => setShowModal(false)}>X</button>
//             <Terms />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState } from "react";
import "./WebinarFormPopup.css";
import qrCodeImage from "../Assets/Payment-Qr.png";
import Terms from '../components/Terms';
import { motion } from "framer-motion";

export default function WebinarForm() {
  const initialFormData = {
    firstName: "",
    lastName: "",
    profession: "",
    course: "",
    phone: "",
    email: "",
    batch: "",
    message: "",
    paymentScreenshot: null,
    termsAccepted: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [showQRCode, setShowQRCode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [callbackPhone, setCallbackPhone] = useState("");
  const [callbackLoading, setCallbackLoading] = useState(false);
  const [callbackError, setCallbackError] = useState("");

  const courses = [
    { name: "Basic" /*, amount: 2400 */ },
    { name: "Intermediate" /*, amount: 6000 */ },
    { name: "Advanced" /*, amount: 7800 */ },
    { name: "TOEFL" /*, amount: 12300 */ },
    { name: "IELTS" /*, amount: 12300 */ },
  ];

  const batches = [
    "1st Sept 2025 – Morning 7am batch (45 minutes)",
    "1st Sept 2025 – Evening 7pm batch (45 minutes)",
    "5th Sept 2025 – Morning 6am batch (45 minutes)",
    "5th Sept 2025 – Evening 8pm batch (45 minutes)",
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleReset = () => {
    setFormData(initialFormData);
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/; // exactly 10 digits

    if (!formData.profession.trim()) newErrors.profession = "Profession is required";
    if (!formData.course) newErrors.course = "Please select a course";
    if (!formData.batch) newErrors.batch = "Please select a batch";

    // Phone validation (required)
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    // Email validation (optional, but must be valid if present)
    if (formData.email.trim() && !emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.termsAccepted) newErrors.termsAccepted = "You must accept the terms";

    return newErrors;
  };

  const validatePhone = (number) => {
    // Accepts 10 digits, optional +91 or 0 at start
    const regex = /^(\+91|0)?[6-9]\d{9}$/;
    return regex.test(number);
  };

  const handleCallbackSubmit = async (e) => {
    e.preventDefault();

    if (!validatePhone(callbackPhone)) {
      setCallbackError("Please enter a valid 10-digit mobile number");
      return;
    }

    setCallbackError("");
    setCallbackLoading(true);

    try {
      const res = await fetch("https://express-brown-omega.vercel.app/api/callbackphone", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: callbackPhone }),
      });

      const data = await res.json();
      alert(data.message);
      setCallbackPhone("");
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setCallbackLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setSubmitting(true);
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });
      console.log({
        "name": `${formData.firstName} ${formData.lastName}`,
        "profession": formData.profession,
        "phone": formData.phone,
        "email": formData.email,
        "message": formData.message,
        "batch": formData.batch,
        "course": formData.course,
        "termsAccepted": true
      })
      const response = await fetch("https://express-brown-omega.vercel.app/api/enrollmentmail", {
        method: "POST",
        body: JSON.stringify({
          "name": `${formData.firstName} ${formData.lastName}`,
          "profession": formData.profession,
          "phone": formData.phone,
          "email": formData.email,
          "message": formData.message,
          "batch": formData.batch,
          "course": formData.course,
          "termsAccepted": true
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    

      const result = await response.json();
     

      if (result.success === true) {
        //setShowQRCode(true);
        handleReset();
        alert(result.message);
      }
    } catch (error) {
      alert("An error occurred while sending the form. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  const selectedCourse = courses.find((c) => c.name === formData.course);

  return (
    <div className="webinar-container">
      <h2 style={{ textAlign: "center" }}>Enroll to Our Course</h2>
      {/* <p style={{ textAlign: "center" }}>✨ Kickstart your journey with our Beginner's and Intermediate Courses starting on 24th September — 
        with batches at 7 AM, 11:30 AM, and 8 PM. 🚀</p> */}

      <form onSubmit={handleSubmit} className="webinar-form">
        <input type="text" name="firstName" placeholder="First Name*" value={formData.firstName} onChange={handleChange} required />
        <input type="text" name="lastName" placeholder="Last Name*" value={formData.lastName} onChange={handleChange} required />

        <div>
          <input type="text" name="profession" placeholder="Profession*" value={formData.profession} onChange={handleChange} required />
          {errors.profession && <p className="error">{errors.profession}</p>}
        </div>

        <div>
          <select name="course" value={formData.course} onChange={handleChange} required>
            <option value="">Select Course*</option>
            {courses.map((c) => (
              <option key={c.name} value={c.name}>{c.name}</option>
            ))}
          </select>
          {/* {selectedCourse && <p className="course-amount">Fees: ₹{selectedCourse.amount}</p>} */}
          {errors.course && <p className="error">{errors.course}</p>}
        </div>

        <div>
          <select
            name="batch"
            value={formData.batch}
            onChange={handleChange}
            required
            disabled={!formData.course}
          >
            <option value="">
              {formData.course ? "Select Batch*" : "Select a Course First"}
            </option>
            {formData.course &&
              batches.map((b, index) => (
                <option key={index} value={b}>
                  {b}
                </option>
              ))}
          </select>
          {errors.batch && <p className="error">{errors.batch}</p>}
        </div>

        <div>
          <input type="tel" name="phone" placeholder="Phone Number*" value={formData.phone} onChange={handleChange} required />
          {errors.phone && <p className="error">{errors.phone}</p>}
        </div>

        <div>
          <input type="email" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} required />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>

        <textarea name="message" placeholder="Any message" value={formData.message} onChange={handleChange} />

        <div className="terms-container">
          <input
            type="checkbox"
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={handleChange}
          />
          <label>
            I agree to the{" "}
            <span className="terms-link" onClick={() => setShowModal(true)}>
              Terms & Conditions
            </span>
          </label>
          {errors.termsAccepted && <p className="error">{errors.termsAccepted}</p>}
        </div>

        <div className="btn-group">
          <button type="button" className="submit-btn" onClick={handleReset}>Reset</button>
          <button type="submit" className="submit-btn" disabled={!formData.termsAccepted || submitting}>
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>

      {/* Moved callback form outside the main form */}
      <motion.form
        onSubmit={handleCallbackSubmit}
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
        className="callback-form"
      >
        <input
          type="tel"
          placeholder="Enter your phone number"
          value={callbackPhone}
          onChange={(e) => setCallbackPhone(e.target.value)}
          required
          className="callback-input"
        />
        <button
          type="submit"
          className="callback-button"
          disabled={callbackLoading}
        >
          {callbackLoading ? "Submitting..." : "Request a Call Back"}
        </button>

        {callbackError && <p className="error-text">{callbackError}</p>}
      </motion.form>

      {showQRCode && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={() => setShowQRCode(false)}>X</button>
            <h3>Scan to Complete Payment</h3>
            <img src={qrCodeImage} alt="QR Code" className="qr-code" />
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={() => setShowModal(false)}>X</button>
            <Terms />
          </div>
        </div>
      )}
    </div>
  );
}